import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { useState } from "react";
import { convertToHTML, convertFromHTML } from "draft-convert";
import inviteContent from "../../helpers/msgTemplates/invite.txt";
import inviteContentHE from "../../helpers/msgTemplates/inviteHE.txt";
import inviteContentAR from "../../helpers/msgTemplates/inviteAR.txt";
import "./richEdit.css";

const languageCode: { [key: string]: string } = {
  English: "EN",
  Hebrew: "HE",
  Arabic: "AR",
};

const languageTemplate: { [key: string]: any } = {
  English: inviteContent,
  Hebrew: inviteContentHE,
  Arabic: inviteContentAR,
};

interface IRichEditComponent {
  msgType: string; // TODO enmu  Email, EmailInvite, Internal, Mobile
  msgLanguage: string;
  onChange: (msg: string) => void;
  onSend: () => void;
}

export const RichEditComponent = ({ msgType, msgLanguage, onChange, onSend }: IRichEditComponent) => {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

  const importTemplate = () => {
    const template = languageTemplate[msgLanguage];
    fetch(template)
      .then((r) => r.text())
      .then((text) => {
        setEditorState(() => EditorState.createWithContent(convertFromHTML(text)));
      });
  };

  const prepareHTML = () => {
    const html = convertToHTML(editorState.getCurrentContent());
    if ((msgType === "Email" || msgType === "EmailInvite") && html !== "<p></p>") {
      onChange(html);
    }
  };

  const handleEditorChange = (state: EditorState) => {
    setEditorState(state);
    prepareHTML();
  };

  return (
    <>
      <Editor editorState={editorState} toolbarClassName="toolbar-class" wrapperClassName="wrapper-class" editorClassName="editor-class" onEditorStateChange={handleEditorChange} />
      <div className="button-container">
        <div className={`LoadTemplate`} onClick={() => importTemplate()}>
          {/* Example SVG Icon (You can replace this with your actual SVG) */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M9 19v-6H5l7-8 7 8h-4v6H9z" />
          </svg>
          Load Invite Template {languageCode[msgLanguage] || "EN"}
        </div>
        <button className="send-message-btn" onClick={onSend}>
          Send Message
        </button>
      </div>
    </>
  );
};
